import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import AiMessageDropdown from 'ducks/ai/components/AiMessageDropdown'
import memoEmoji from 'assets/icons/emoji/memo.png'
// import magicWand from 'assets/icons/emoji/magic-wand.png'
import nerdFace from 'assets/icons/emoji/nerd-face.png'
import luggage from 'assets/icons/emoji/luggage.png'
import manDancing from 'assets/icons/emoji/man-dancing.png'
import writingHand from 'assets/icons/emoji/writing-hand.png'
// import manRisingHand from 'assets/icons/emoji/man-raising-hand.png'
import scroll from 'assets/icons/emoji/scroll.png'
import { selectIsAddingNote } from 'selectors/page'
import { doInitializeRequest } from 'ducks/ai/operations'
import {
  SUMMARY_ACTION,
  SPELLING_ACTION,
  SHORTEN_ACTION,
  LENGTHEN_ACTION,
  FORMAL_ACTION,
  CASUAL_ACTION,
  CLARIFY_ACTION,
  REQUEST_TYPES,
} from 'ducks/ai/types'
import { record } from 'ducks/tracking/actions'

// add isTextSelected as the param in generateItems when we will have more working options
const generateItems = (isNote, editorName) => {
  const ticketActions = {
    name: 'GENERATE FROM CONVERSATION',
    items: [
      {
        id: SUMMARY_ACTION,
        name: 'Generate a summary of the conversation',
        icon: memoEmoji,
      },
      // {
      //   id: 'explain',
      //   name: 'Explain this conversation',
      //   icon: manRisingHand,
      // },
    ],
  }

  let editorActions

  if (editorName) {
    const editorActionSelectionText = isNote ? 'note' : 'reply'
    // const editor = getEditor(editorName)
    // if (isTextSelected(editor)) {
    //   editorActionSelectionText = 'selection'
    // } else if (isNote) {
    //   editorActionSelectionText = 'note'
    // }

    editorActions = {
      name: `EDIT OR REVIEW YOUR ${editorActionSelectionText.toUpperCase()}`,
      items: [
        // {
        //   id: 'improve',
        //   name: 'Improve writing',
        //   icon: magicWand,
        // },
        {
          id: SPELLING_ACTION,
          name: 'Fix spelling & grammar',
          icon: nerdFace,
        },
        {
          id: SHORTEN_ACTION,
          name: 'Make shorter',
          icon: memoEmoji,
        },
        {
          id: LENGTHEN_ACTION,
          name: 'Make longer',
          icon: scroll,
        },
        {
          id: FORMAL_ACTION,
          name: `Make ${editorActionSelectionText} more formal`,
          icon: luggage,
        },
        {
          id: CASUAL_ACTION,
          name: `Make ${editorActionSelectionText} more casual`,
          icon: manDancing,
        },
        {
          id: CLARIFY_ACTION,
          name: 'Simplify language',
          icon: writingHand,
        },
      ],
    }
  }

  return [ticketActions, editorActions]
}

const AiButton = React.memo(({ position = 'top-start', editorName }) => {
  const dispatch = useDispatch()
  const isNote = useSelector(selectIsAddingNote)

  const loadMenu = useCallback(
    () => {
      return generateItems(isNote, editorName)
    },
    [isNote, editorName]
  )

  const onAiOptionSelected = useCallback(
    async item => {
      if (!item?.id) return
      record()
      dispatch(doInitializeRequest(REQUEST_TYPES[item.id], item.id))
    },
    [dispatch]
  )

  return (
    <AiMessageDropdown
      onAiOptionSelected={onAiOptionSelected}
      list={loadMenu}
      position={position}
      // Only show the text modifications callout in the editor
      featureCalloutHidden={!editorName}
    />
  )
})

export default AiButton
